/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Cargo_Updated_Related_FieldsInputs */

const en_cargo_updated_related_fields = /** @type {(inputs: Cargo_Updated_Related_FieldsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cargo updated and changes applied to ${i?.count} related cargos`)
};

const es_cargo_updated_related_fields = /** @type {(inputs: Cargo_Updated_Related_FieldsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carga actualizada y cambios aplicados a ${i?.count} cargas relacionadas`)
};

/**
* | output |
* | --- |
* | "Cargo updated and changes applied to {count} related cargos" |
*
* @param {Cargo_Updated_Related_FieldsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_updated_related_fields = /** @type {((inputs: Cargo_Updated_Related_FieldsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Updated_Related_FieldsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_updated_related_fields(inputs)
	return es_cargo_updated_related_fields(inputs)
});